<template>
  <div class="my-4">
    みんなの読んだ本を検索する
    <div class="input-group mb-3">
      <input
        type="text"
        class="form-control"
        placeholder="Enter Searching Target"
        aria-label="Recipient's username"
        aria-describedby="button-addon2"
        v-model="searchTarget"
      />
      <div class="input-group-append">
        <button
          class="btn btn-outline-secondary"
          type="button"
          id="button-addon2"
          v-on:click="searchBook()"
        >
          検索
        </button>
      </div>
    </div>
    <div class="books-wrapper">
      <BookCard
        :book="book"
        v-for="(book, index) in books"
        v-bind:key="index"
      />
    </div>
    <b-button @click="fetchNextBooks" v-if="!finished" class="mt-4">
      もっと見る
    </b-button>
  </div>
</template>

<script>
import { db } from "@/firebase";
import BookCard from "../components/BookCard.vue";
const booksDB = db.collection("books");

export default {
  data: function() {
    return {
      searchTarget: "",
      books: [],
      lastBookCreatedAt: "",
      finished: false
    };
  },
  methods: {
    fetchBooks() {
      booksDB
        .orderBy("createdAt", "desc")
        .limit(18)
        .get()
        .then(snapshots => {
          snapshots.docs.forEach(snapshot => {
            const book = snapshot.data();
            book.id = snapshot.id;
            this.books.push(book);
          });
          this.lastBookCreatedAt = snapshots.docs[
            snapshots.docs.length - 1
          ].data().createdAt;
        });
    },
    fetchNextBooks() {
      booksDB
        .orderBy("createdAt", "desc")
        .startAfter(this.lastBookCreatedAt)
        .limit(18)
        .get()
        .then(snapshots => {
          console.log(this.books);
          if (snapshots.docs.length < 18) {
            this.finished = true;
          }
          snapshots.docs.forEach(snapshot => {
            const book = snapshot.data();
            book.id = snapshot.id;
            this.books.push(book);
          });
          this.lastBookCreatedAt = snapshots.docs[
            snapshots.docs.length - 1
          ].data().createdAt;
        });
    },
    searchBook() {
      this.books = [];
      db.collection("books")
        .orderBy("bookTitle")
        .startAt(this.searchTarget)
        .endAt(this.searchTarget + "\uf8ff")
        .get()
        .then(docs => {
          docs.forEach(doc => {
            const book = doc.data();
            book.id = doc.id;
            this.books.push(book);
          });
          this.finished = true;
        });
    }
  },
  created() {
    this.fetchBooks();
  },
  components: {
    BookCard
  }
};
</script>

<style lang="scss">
.books-wrapper {
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 90%;

  @media screen and (max-width: 560px) {
    justify-content: center;
  }
}
</style>
